import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        VDatePicker,
        {
          attrs: {
            "no-title": "",
            min: _vm.minDate,
            "first-day-of-week": _vm.params.firstDayOfWeek,
            locale: _vm.params.locale,
            "picker-date": _vm.pickerDate,
            range: _vm.isRangeMode,
            "show-current": "",
          },
          on: { input: _vm.handleDateInput },
          model: {
            value: _vm.dateValue,
            callback: function ($$v) {
              _vm.dateValue = $$v
            },
            expression: "dateValue",
          },
        },
        [
          _c(VSpacer),
          _vm._v(" "),
          _vm._l(_vm.params.actions, function (action) {
            return _c(
              VBtn,
              {
                key: action.label,
                attrs: {
                  text: "",
                  outlined: "",
                  depressed: "",
                  small: "",
                  color: "primary",
                },
                on: { click: action.callback },
              },
              [_vm._v("\n      " + _vm._s(action.label) + "\n    ")]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }